<template>
  <el-checkbox
    v-model="checked"
    :disabled="disabled"
    :class="{
      'button-checkbox': buttonType,
    }"
    :indeterminate="isIndeterminate"
    @change="changeCheck">
    <slot></slot>
  </el-checkbox>
</template>
<script>
export default {
  name: 'VCheckbox',
  props: {
    value: {
      type: [String, Boolean, Number],
      default: false
    },
    disabled:{
      type:Boolean,
      default: false
    },
    isIndeterminate:{
      type:Boolean,
      default: false
    },
    isBoolean: {
      type: Boolean,
      default: true //  準備改成 false todo
    },
    selectNumber:{
      type: [Boolean, Number],
      default: 1
    },
    noNumber:{
      type: [Boolean, Number],
      default: 0
    },
    otherData:{
      type: Object,
      default: () => {}
    },
    buttonType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.checked = val==this.selectNumber
        let result = this.isBoolean? val: Number(val)
        if(!this.isBoolean&&this.selectNumber>1){
          result = this.checked?this.selectNumber:0
        }
        if(!this.isBoolean&&this.noNumber>0){
          result = this.checked?this.selectNumber:this.noNumber
        }
        this.$emit('input', result)
      }
    },
  },
  methods: {
    changeCheck(val) {
      let result = this.isBoolean? val: Number(val)
      if(!this.isBoolean&&this.noNumber>0){
        result = this.checked?this.selectNumber:this.noNumber
      }
      if(!this.isBoolean&&this.selectNumber>1){
        result = this.checked?this.selectNumber:this.noNumber
      }
      this.$emit('input', result)
      this.$emit('change', result, this.otherData)
    }
  }
}
</script>
<style lang="scss" scoped>
 .el-checkbox{
  display: flex;
  align-items: center!important;
   /deep/ .el-checkbox__input{
     height: 14px;
   }
   /deep/.el-checkbox__label{
      white-space: normal;
     line-height: 14px;
}
   &.button-checkbox {
     /deep/ .el-checkbox__input {
       display: none;
     }
     /deep/ .el-checkbox__label {
       display: flex;
       justify-content: center;
       align-items: center;
       margin-left: 0;
       padding: 10px 12px;
       min-width: 50px;
       min-height: 45px;
       height: 100%;
       border-radius: 8px;
       border: 1px solid $blue;
       font-size: 16px;
       line-height: 21px;
       color: $blue;
       text-align: center;
       transition: all 0.1s;
       &:hover {
        opacity: 0.6;
       }

     }
        &.is-checked {
    /deep/ .el-checkbox__label {
         color: #fff!important;
         background: $blue!important;
       }
     }
   }
}
</style>
